import HomeIcon from "@mui/icons-material/Home";
import { Box, Divider, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import T from "../../common/traducao";
import CardComponent from "../../components/ui_comp/Cards/cardComponent";
import { getAcessoSimulado, GetPermissaoVisualizar, getUserLogin } from "../../config/localstorageConfig/localstorage";

const Home = () => {
  const [userLogin] = useState(getUserLogin());
  const vendedorSimulado = getAcessoSimulado();

  const mostrarCliente = (process.env.REACT_APP_USAR_CLIENTE === "true") && GetPermissaoVisualizar("cliente");
  const mostrarOrcamentoVenda = GetPermissaoVisualizar("orcamentovenda");
  const mostrarAssistencia = (process.env.REACT_APP_USAR_ASSISTENCIA === "true") && GetPermissaoVisualizar("assistencia");
  const mostrarPedidoVenda = (process.env.REACT_APP_USAR_PEDIDO === "true") && GetPermissaoVisualizar("pedidosvenda");

  const constantes = T();
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, padding: 3, height: "100%" }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={1}>
          <HomeIcon sx={{ color: "#009180" }} />
          <Typography variant="h6" component="h5" sx={{ color: "#009180" }}>
            {constantes.Home}
          </Typography>
        </Box>
      </Box>

      <Divider color="primary" sx={{ marginBottom: 2 }} />

      <Typography variant="h5" component="span" sx={{ color: "#009180" }}>
        {constantes.BemVindo} {vendedorSimulado ? vendedorSimulado.Nome : userLogin}
      </Typography>

      <Grid container spacing={2} sx={{ marginLeft: isLg ? -2 : 0 }}>
        {mostrarCliente &&
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CardComponent
              titulo={constantes.Clientes}
              categoria={constantes.Modulo}
              descricao={constantes.MsgCardClientes}
              descricaoImage={constantes.Clientes}
              route="/clientes"
              icone="people_alt"
            />
          </Grid>
        }

        {mostrarOrcamentoVenda &&
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CardComponent
              titulo={constantes.OrcamentosDeVenda}
              categoria={constantes.Modulo}
              descricao={constantes.MsgCardHome}
              descricaoImage={constantes.OrcamentosDeVenda}
              route="/orcamentosvenda"
              icone="receipt_long"
            />
          </Grid>
        }

        {mostrarPedidoVenda &&
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CardComponent
              titulo={constantes.PedidoVendas}
              categoria={constantes.Modulo}
              descricao={constantes.MsgCardPedidos}
              descricaoImage={constantes.PedidoVendas}
              route="/pedidosvenda"
              icone="receipt_long"
            />
          </Grid>
        }

        {mostrarAssistencia &&
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <CardComponent
              titulo={constantes.Assistencias}
              categoria={constantes.Modulo}
              descricao={constantes.MsgCardAssistencia}
              descricaoImage={constantes.Assistencias}
              route="/assistencias"
              icone="settings"
            />
          </Grid>
        }
      </Grid>
    </Box>
  );
};

export default Home;
